import React, { useEffect, useMemo, useState, useCallback } from 'react';
import classnames from 'classnames';
import type { GetServerSideProps, InferGetServerSidePropsType } from 'next';
import ScrollableAnchor, { configureAnchors } from 'react-scrollable-anchor';
import { cloneDeep, compact, debounce, isEqual, uniqBy } from 'lodash';
import { useSetState } from 'ahooks';
// import { Select } from 'antd';
import moment from 'moment';
import SearchSelect from '@/business-components/SearchSelect';
import MenuAnchor from '@/business-components/menuAnchor';
import Footer from '@/business-components/footer';
// import TabsAnchor from '@/business-components/tabs-anchor';
import Dot from '@/components/Dot';
import Layout from '@/layouts';
import { ConBrandWebController } from '@/services/swagger/ConBrandWebController';
import ChartHeader from '@/business-components/chart-header';
import type { ConBrandWebV1FindResponse } from '@/services/swagger/data-contracts';
import ServerSideFetch from '@/utils/server-side-fetch';
import { ConBrandDetailsWebController } from '@/services/swagger/ConBrandDetailsWebController';
// import { Report } from '@/interface/report';
import Button from '@/components/button';
import TooltipBase from '@/components/tooltip';
// import CustomEmpty from '@/business-components/CustomEmpty';
import UserScale from './components/developmentAbility/userScale';
import StoreSituation from './components/developmentAbility/storeSituation';
import ConsumerComplaints from './components/developmentAbility/consumerComplaints';
import SearchPopularitye from './components/developmentAbility/searchPopularity';
import UserPraise from './components/developmentAbility/userPraise';
import UserOpinion from './components/developmentAbility/userOpinion';
import FinancingEnv from './components/potential/financingEnv';
import FinancingSchedule from './components/potential/financingSchedule';
import GrowthSpace from './components/potential/growthSpace';
import DiscussionHeat from './components/potential/discussionHeat';
import Operate from './components/operate';
import Competitiveness from './components/competitiveness';
// import Perfection from './components/supplychain/perfection';
import Efficiency from './components/supplychain/efficiency';
// import Interaction from './components/marketingCapability/interaction';
import ProductionCapacity from './components/marketingCapability/productionCapacity';
import PlatformRelated from './components/marketingCapability/platformRelated';
// import BrandGrowth from './components/brandGrowth';
import FilterBrand from './components/filterBrand';
import Organize from './components/organize';
import Add from 'assets/add.svg';
import styles from './index.module.scss';

configureAnchors({ offset: -56, scrollDuration: 200 });
let firstFlag = true;

export const defaultMonthVal: any = moment(moment().format('YYYY-MM-DD'), 'YYYY-MM');
export const disabledDate = (current): boolean => {
  return current.valueOf() > moment().valueOf();
};
// moment(moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'), 'YYYY-MM'),

// submenu keys of first level

const controller = new ConBrandWebController();
const controllerDetail = new ConBrandDetailsWebController();
const brandDetailController = new ConBrandDetailsWebController();
export type IndexPageServiderProps = {
  conBrandId: string;
  brandInfo?: ConBrandWebV1FindResponse;
  growIndexList: any[];
  indexScoreList: any[];
};
export const getServerSideProps: GetServerSideProps<IndexPageServiderProps, { id: string }> = async ({
  res,
  params,
}) => {
  res.setHeader('Cache-Control', 'public, s-maxage=15, stale-while-revalidate=59');
  const { id: conBrandId } = params;
  let brandInfo = null;
  const brandInfoRes = await ServerSideFetch(controller.conBrandWebControllerV1FindUsingGet1, {
    conBrandId,
  });
  if (brandInfoRes?.code === 200) {
    brandInfo = brandInfoRes?.data || {};
  } else {
    return { notFound: true };
  }
  const { data: index_data } = await ServerSideFetch(controller.conBrandWebControllerV1IndexDataUsingGet1, {
    conBrandId,
  });
  // const { data: report } = await getRelatedReportList({ keyword: brandInfo.chName || brandInfo.ehName, pageSize: 10 });

  return {
    props: {
      conBrandId,
      brandInfo: { ...brandInfo, chName: brandInfo?.chName || brandInfo?.ehName || '' },
      growIndexList: index_data?.growIndexList || [],
      indexScoreList: index_data?.indexScoreList || [],
    },
  };
};
function BrandContrastPage({
  conBrandId,
  brandInfo,
  growIndexList,
  indexScoreList,
}: InferGetServerSidePropsType<typeof getServerSideProps>) {
  const [selectValue, setSelectValue] = useState(undefined);
  const [selectedKeys, setSelectedKeys] = useState(['tabs-2']);
  const [openKeys, setOpenKeys] = useState(['1']);
  const [selectListCache, setSelectListCache] = useState([brandInfo]);
  const [selectList, setSelectList] = useState([brandInfo]);
  const [addSelectItem, setAddSelectItem] = useState(brandInfo);
  const [removeSelectItem, setRmoveSelectItem] = useState(null);
  const [empty, setEmpty] = useState(false);
  const [compared, setCompared] = useSetState({
    growIndexList: growIndexList?.map(item => ({
      ...item,
      ...brandInfo,
    })),
    indexScoreList: indexScoreList?.map(item => ({
      ...item,
      ...brandInfo,
    })),
    financingInfoList: [],
    finanncingList: [],
    industryGrowSpaceList: [],
    business_capacity: [],
    hotTalkList: [],
    fansList: [],
    userNiceList: [],
    brandHotSearchList: [],
    conBrandEsgList: [],
    userOpinion: [],
    interactionList: [],
    productionList: [],
    relatedContentList: [],
    organStrength: [],
    organCompetencies: [],
    organPenetrate: [],
    brandStoreChartsList: [],
    brandStoreCityList: [],
    supplyChain: [],
    brandproductinfo: [],
  });
  const getLockStastus = useCallback(async () => {
    const { data: user_brand_auth } = await ServerSideFetch(controller.conBrandWebControllerV1UserBrandAuthUsingGet1, {
      conBrandId,
    });
    setSelectList([{ ...selectList?.[0], ...user_brand_auth }]);
    setSelectListCache([{ ...selectList?.[0], ...user_brand_auth }]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [conBrandId]);
  useEffect(() => {
    getLockStastus();
  }, [getLockStastus]);
  const hasUnlock = useMemo(() => {
    return selectList.every((item: any) => item?.hasUnlocked);
  }, [selectList]);
  const filterHandle = arr => {
    return arr?.filter(item => item.conBrandId !== removeSelectItem?.conBrandId);
  };
  const [disabledClose, setDisabledClose] = useState(false);
  const handleSelectData = async () => {
    setDisabledClose(true);
    if (addSelectItem) {
      const { data: index_data } = await ServerSideFetch(controller.conBrandWebControllerV1IndexDataUsingGet1, {
        conBrandId: addSelectItem?.conBrandId,
      });
      const { data: brandInfo } = await ServerSideFetch(
        brandDetailController.conBrandDetailsWebControllerV1BrandDetailOrganUsingGet1,
        {
          conBrandId: addSelectItem?.conBrandId,
        }
      );
      const { data: financingInfo } = await ServerSideFetch(
        controller.conBrandWebControllerV1TrackBrandPotentialUsingGet1,
        {
          conBrandId: addSelectItem?.conBrandId,
        }
      );
      const { data: business_capacity } = await ServerSideFetch(
        controller.conBrandWebControllerV1BusinessCapacityUsingGet1,
        {
          conBrandId: addSelectItem?.conBrandId,
        }
      );
      const { data: userscalenice } = await ServerSideFetch(
        brandDetailController.conBrandDetailsWebControllerV1UserScaleNiceUsingGet1,
        {
          conBrandId: addSelectItem?.conBrandId,
        }
      );
      const { data: underline } = await ServerSideFetch(
        brandDetailController.conBrandDetailsWebControllerV1BrandStoreUsingGet1,
        { conBrandId: addSelectItem?.conBrandId }
      );
      const { data: marketing } = await ServerSideFetch(controller.conBrandWebControllerV1MarketingCapacityUsingGet1, {
        conBrandId: addSelectItem?.conBrandId,
      });
      const { data: development } = await ServerSideFetch(
        brandDetailController.conBrandDetailsWebControllerV1EsgAndHotSearchUsingGet1,
        { conBrandId: addSelectItem?.conBrandId }
      );
      const { data: userOpinion } = await ServerSideFetch(
        brandDetailController.conBrandDetailsWebControllerV1SocialUserOpinionUsingGet1,
        {
          conBrandId: addSelectItem?.conBrandId,
          // month: new Date().getMonth() + 1,
          // yearStr: new Date().getFullYear(),
        }
      );
      const { data: supplyChainData } = await ServerSideFetch(controller.conBrandWebControllerV1SupplyChainUsingGet1, {
        conBrandId: addSelectItem?.conBrandId,
      });
      const { data: brandproductinfo } = await ServerSideFetch(
        controllerDetail.conBrandDetailsWebControllerV1BrandProductInfoUsingGet1,
        {
          conBrandId: addSelectItem?.conBrandId,
        }
      );
      if (empty) {
        setEmpty(false);
        setCompared({
          growIndexList: [
            ...(index_data?.growIndexList?.map(item => ({
              ...item,
              ...addSelectItem,
            })) || []),
          ],
          indexScoreList: [
            ...(index_data?.indexScoreList?.map(item => ({
              ...item,
              ...addSelectItem,
            })) || []),
          ],
          financingInfoList: [{ ...financingInfo, ...addSelectItem }],
          finanncingList: [{ list: financingInfo?.financeList, ...addSelectItem }],
          industryGrowSpaceList: [
            {
              list: financingInfo?.industryGrowSpaceList?.map(item => ({ ...item, ...addSelectItem })) || [],
              ...addSelectItem,
              ...financingInfo,
            },
          ],
          hotTalkList: [
            {
              list: financingInfo?.hotTalkList?.map(item => ({ ...item, ...addSelectItem })) || [],
              ...addSelectItem,
              ...financingInfo,
            },
          ],
          business_capacity: [
            {
              list: business_capacity?.nonBigPromotionList?.map(item => ({ ...item, ...addSelectItem })) || [],
              ...business_capacity,
              ...addSelectItem,
            },
          ],
          fansList: [
            {
              list: userscalenice?.fansList?.map(item => ({ ...item, ...addSelectItem })) || [],
              ...addSelectItem,
              totalFans: userscalenice?.totalFans,
            },
          ],
          userNiceList: [
            { list: userscalenice?.userNiceList?.map(item => ({ ...item, ...addSelectItem })) || [], ...addSelectItem },
          ],
          productionList: [
            { list: marketing?.productionList?.map(item => ({ ...item, ...addSelectItem })) || [], ...addSelectItem },
          ],
          relatedContentList: [
            { list: marketing?.productionList?.map(item => ({ ...item, ...addSelectItem })) || [], ...addSelectItem },
          ],
          interactionList: [
            {
              list: [
                ...(marketing?.forwardList
                  ? marketing?.forwardList?.map(item => ({ ...item, ...addSelectItem, type: 'forword' }))
                  : []),
                ...(marketing?.likeList
                  ? marketing?.likeList?.map(item => ({ ...item, ...addSelectItem, type: 'like' }))
                  : []),
                ...(marketing?.commentList
                  ? marketing?.commentList?.map(item => ({ ...item, ...addSelectItem, type: 'comment' }))
                  : []),
              ],
              ...addSelectItem,
              totalFans: userscalenice?.totalFans,
            },
          ],
          brandStoreChartsList: [
            {
              list: underline?.brandStoreChartsList?.map(item => ({ ...item, ...addSelectItem })) || [],
              ...addSelectItem,
              storeTotalNum: underline?.storeTotalNum,
            },
          ],
          brandStoreCityList: [
            {
              list: underline?.brandStoreCityList?.map(item => ({ ...item, ...addSelectItem })) || [],
              ...addSelectItem,
              storeTotalNum: underline?.storeTotalNum,
            },
          ],

          conBrandEsgList: [
            {
              list: development?.conBrandEsgList?.map(item => ({ ...item, ...addSelectItem })) || [],
              consumerComplaintTotalNum: development?.consumerComplaintTotalNum,
              ...addSelectItem,
            },
          ],
          brandHotSearchList: [
            {
              list: development?.brandHotSearchList?.map(item => ({ ...item, ...addSelectItem })) || [],
              ...addSelectItem,
            },
          ],
          userOpinion: [
            { list: userOpinion?.brandEvaluateList?.map(item => ({ ...item, ...addSelectItem })), ...addSelectItem },
          ],
          organStrength: [{ ...brandInfo?.conBrandParentCompanyVo, ...addSelectItem }],
          organCompetencies: [
            { list: brandInfo?.conBrandGroupList?.map(item => ({ ...item, ...addSelectItem })), ...addSelectItem },
          ],
          organPenetrate: [
            {
              list: brandInfo?.conParentCompanyProductVo?.list?.map(item => ({ ...item, ...addSelectItem })),
              ...addSelectItem,
              ...brandInfo?.conParentCompanyProductVo,
            },
          ],
          supplyChain: [{ ...supplyChainData, ...addSelectItem }],
          brandproductinfo: [{ ...brandproductinfo, ...addSelectItem }],
          // userNiceList: [{ list: financingInfo?.userNiceList, ...addSelectItem }],
        });
      } else {
        setCompared({
          growIndexList: [
            ...(compared?.growIndexList || []),
            ...(index_data?.growIndexList?.map(item => ({
              ...item,
              ...addSelectItem,
            })) || []),
          ],
          indexScoreList: [
            ...(compared?.indexScoreList || []),
            ...(index_data?.indexScoreList?.map(item => ({
              ...item,
              ...addSelectItem,
            })) || []),
          ],
          financingInfoList: [...compared?.financingInfoList, { ...financingInfo, ...addSelectItem }],
          finanncingList: [...compared?.finanncingList, { list: financingInfo?.financeList, ...addSelectItem }],
          industryGrowSpaceList: [
            ...compared?.industryGrowSpaceList,
            {
              list: financingInfo?.industryGrowSpaceList?.map(item => ({ ...item, ...addSelectItem })) || [],
              ...addSelectItem,
              ...financingInfo,
            },
          ],
          hotTalkList: [
            ...compared?.hotTalkList,
            {
              list: financingInfo?.hotTalkList?.map(item => ({ ...item, ...addSelectItem })) || [],
              ...addSelectItem,
              ...financingInfo,
            },
          ],
          business_capacity: [
            ...compared?.business_capacity,
            {
              list: business_capacity?.nonBigPromotionList?.map(item => ({ ...item, ...addSelectItem })) || [],
              ...business_capacity,
              ...addSelectItem,
            },
          ],
          fansList: [
            ...compared?.fansList,
            {
              list: userscalenice?.fansList?.map(item => ({ ...item, ...addSelectItem })) || [],
              ...addSelectItem,
              totalFans: userscalenice?.totalFans,
            },
          ],
          userNiceList: [
            ...compared?.userNiceList,
            { list: userscalenice?.userNiceList?.map(item => ({ ...item, ...addSelectItem })) || [], ...addSelectItem },
          ],
          conBrandEsgList: [
            ...compared?.conBrandEsgList,
            {
              list: development?.conBrandEsgList?.map(item => ({ ...item, ...addSelectItem })) || [],
              consumerComplaintTotalNum: development?.consumerComplaintTotalNum,
              ...addSelectItem,
            },
          ],
          brandHotSearchList: [
            ...compared?.brandHotSearchList,
            {
              list: development?.brandHotSearchList?.map(item => ({ ...item, ...addSelectItem })) || [],
              ...addSelectItem,
            },
          ],
          userOpinion: [
            ...compared?.userOpinion,
            {
              list: userOpinion?.brandEvaluateList?.map(item => ({ ...item, ...addSelectItem })) || [],
              ...addSelectItem,
            },
          ],
          productionList: [
            ...compared?.productionList,
            { list: marketing?.productionList?.map(item => ({ ...item, ...addSelectItem })) || [], ...addSelectItem },
          ],
          relatedContentList: [
            ...compared?.relatedContentList,
            {
              list: marketing?.relatedContentList?.map(item => ({ ...item, ...addSelectItem })) || [],
              ...addSelectItem,
            },
          ],
          interactionList: [
            ...compared?.interactionList,
            {
              list: [
                ...(marketing?.forwardList
                  ? marketing?.forwardList?.map(item => ({ ...item, ...addSelectItem, type: 'forword' }))
                  : []),
                ...(marketing?.likeList
                  ? marketing?.likeList?.map(item => ({ ...item, ...addSelectItem, type: 'like' }))
                  : []),
                ...(marketing?.commentList
                  ? marketing?.commentList?.map(item => ({ ...item, ...addSelectItem, type: 'comment' }))
                  : []),
              ],
              ...addSelectItem,
              totalFans: userscalenice?.totalFans,
            },
          ],
          organStrength: [...compared?.organStrength, { ...brandInfo?.conBrandParentCompanyVo, ...addSelectItem }],
          organCompetencies: [
            ...compared?.organCompetencies,
            {
              list: brandInfo?.conBrandGroupList?.map(item => ({ ...item, ...addSelectItem })) || [],
              ...addSelectItem,
            },
          ],
          organPenetrate: [
            ...compared?.organPenetrate,
            {
              list: brandInfo?.conParentCompanyProductVo?.list?.map(item => ({ ...item, ...addSelectItem })) || [],
              ...addSelectItem,
              ...brandInfo?.conParentCompanyProductVo,
            },
          ],
          brandStoreChartsList: [
            ...compared?.brandStoreChartsList,
            {
              list: underline?.brandStoreChartsList?.map(item => ({ ...item, ...addSelectItem })) || [],
              ...addSelectItem,
              storeTotalNum: underline?.storeTotalNum,
            },
          ],
          brandStoreCityList: [
            ...compared?.brandStoreCityList,
            {
              list: underline?.brandStoreCityList?.map(item => ({ ...item, ...addSelectItem })) || [],
              ...addSelectItem,
              storeTotalNum: underline?.storeTotalNum,
            },
          ],
          supplyChain: [...compared?.supplyChain, { ...supplyChainData, ...addSelectItem }],
          brandproductinfo: [...compared?.brandproductinfo, { ...brandproductinfo, ...addSelectItem }],
        });
      }
    } else if (removeSelectItem) {
      if (selectList.length > 0) {
        const comparedData = cloneDeep(compared);
        Object.keys(comparedData)?.map(keys => {
          comparedData[keys] = filterHandle(comparedData?.[keys]);
        });
        setCompared(comparedData);
      } else {
        setEmpty(true);
      }
    }
    setDisabledClose(false);
  };
  useEffect(() => {
    if (!firstFlag) {
      handleSelectData();
    } else {
      firstFlag = false;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectList, setCompared]);
  useEffect(() => {
    addEventListener(
      'scroll',
      debounce(() => {
        if (location.hash) {
          setSelectedKeys([location.hash.replace('#', '')]);
          setOpenKeys([location.hash.replace('#tabs-', '')]);
        } else {
          setSelectedKeys(['tabs-1']);
          // setOpenKeys(['1']);
        }
      }, 150)
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    window.location.hash = '';
  }, []);
  const onTabSelect = key => {
    location.hash = key;
  };
  const tabArr = useMemo(
    () => [
      {
        id: '2',
        content: (
          <div className={styles.brandFilter}>
            <ChartHeader
              title={
                <span className={classnames('flex-row-nowrap', 'flex-center-center', styles.title)}>
                  品牌综合对比
                  {typeof window !== 'undefined' && (
                    <SearchSelect
                      className={styles.seelctBrand}
                      request={controller.conBrandWebControllerV1CompareSelectUsingGet1}
                      allowClear
                      placeholder="请选择要对比的品牌"
                      style={{ width: '200px' }}
                      labelKey="chName"
                      valueKey="conBrandId"
                      showSearch
                      showArrow={false}
                      selectList={selectList}
                      disabled={selectList?.length === 3}
                      value={selectValue}
                      searchKey="brandName"
                      filterOption={false}
                      optionLabelFilter={list =>
                        list?.map(item =>
                          !!selectList.find(unit => unit.conBrandId === item.conBrandId)
                            ? { ...item, disabled: true }
                            : { ...item, disabled: false }
                        )
                      }
                      onChange={(id, record) => {
                        setSelectValue(id);
                        setSelectListCache(uniqBy(compact([...selectList, record]), 'conBrandId'));
                        setAddSelectItem(record);
                      }}
                    />
                  )}
                  <Button
                    width={110}
                    height={32}
                    className={styles.addBrand}
                    onClick={() => {
                      setCompared({});
                      if (!isEqual(selectList, selectListCache)) {
                        setSelectList(selectListCache);
                      }
                      setSelectValue(undefined);
                    }}
                  >
                    <div className={classnames('flex-row-nowrap', 'flex-center-center')}>
                      <Add />
                      <span style={{ marginLeft: '5px' }}>添加品牌</span>
                    </div>
                  </Button>
                </span>
              }
              titleFontSize={20}
            ></ChartHeader>
            <FilterBrand
              data={selectList}
              onClose={(val, record) => {
                if (disabledClose) return;
                setAddSelectItem(null);
                setRmoveSelectItem(record);
                setSelectList(selectList.filter(item => item.conBrandId !== val));
                setSelectListCache(selectListCache.filter(item => item.conBrandId !== val));
              }}
            />
            {/*<BrandGrowth*/}
            {/*  data={{*/}
            {/*    growIndexList: compared?.growIndexList,*/}
            {/*    indexScoreList: compared?.indexScoreList,*/}
            {/*  }}*/}
            {/*/>*/}
          </div>
        ),
      },
      {
        id: '2-1',
        content: (
          <div>
            <Organize
              hasUnlock={hasUnlock}
              data={{
                organStrength: compared?.organStrength,
                organCompetencies: compared?.organCompetencies,
                organPenetrate: compared?.organPenetrate,
              }}
            />
          </div>
        ),
      },
      {
        id: '3',
        content: (
          <div>
            <Operate data={compared?.business_capacity} hasUnlock={hasUnlock} />
          </div>
        ),
      },
      {
        id: '4',
        content: (
          <ChartHeader
            title={
              <h1 className={styles.moduleTitle}>
                行业及品牌发展潜力
                <TooltipBase
                  title={
                    <>
                      <p>行业发展潜力：由行业消费规模、行业融资环境、行业讨论热度等维度搭建的数学模型计算得出。</p>
                      <p>行业及品牌发展潜力数据来源：CBNData数据库、天眼查</p>
                    </>
                  }
                  placement="right"
                />
              </h1>
            }
            titleFontSize={18}
            className={styles.header}
          />
        ),
      },
      {
        id: '4-1',
        content: (
          <div style={{ paddingBottom: '20px' }}>
            <FinancingEnv data={compared?.financingInfoList} />
          </div>
        ),
      },
      {
        id: '4-2',
        content: (
          <div style={{ paddingBottom: '20px' }}>
            <FinancingSchedule data={compared?.finanncingList} />
          </div>
        ),
      },
      {
        id: '4-3',
        content: (
          <>
            <div style={{ paddingBottom: '20px' }}>
              <GrowthSpace data={compared?.industryGrowSpaceList} hasUnlock={hasUnlock} />
            </div>
          </>
        ),
      },
      {
        id: '4-4',
        content: (
          <>
            <div style={{ paddingBottom: '20px' }}>
              <DiscussionHeat data={compared?.hotTalkList} hasUnlock={hasUnlock} />
            </div>
          </>
        ),
      },
      {
        id: '5',
        content: <ChartHeader title="产品竞争能力" titleFontSize={18} className={styles.header} />,
      },
      {
        id: '5-1',
        content: (
          <div style={{ paddingBottom: '20px' }}>
            <Competitiveness data={compared?.brandproductinfo} />
          </div>
        ),
      },
      {
        id: '6',
        content: <ChartHeader title="供应链管理能力" titleFontSize={18} className={styles.header} />,
      },
      // {
      //   id: '6-1',
      //   content: (
      //     <>
      //       {hasUnlock && (
      //         <div style={{ paddingBottom: '20px' }}>
      //           <Perfection data={compared?.supplyChain} />
      //         </div>
      //       )}
      //     </>
      //   ),
      // },
      {
        id: '6-2',
        content: (
          <div style={{ paddingBottom: '20px' }}>
            <Efficiency data={compared?.supplyChain} />
          </div>
        ),
      },
      {
        id: '7',
        content: <ChartHeader title="用户发展能力" titleFontSize={18} className={styles.header} />,
      },
      {
        id: '7-1',
        content: (
          <div style={{ paddingBottom: '20px' }}>
            <UserScale data={compared?.fansList} />
          </div>
        ),
      },
      {
        id: '7-2',
        content: (
          <>
            <div style={{ paddingBottom: '20px' }}>
              <UserPraise data={compared?.userNiceList} hasUnlock={hasUnlock} />
            </div>
          </>
        ),
      },
      {
        id: '7-3',
        content: (
          <div style={{ paddingBottom: '20px' }}>
            <StoreSituation
              data={{
                brandStoreChartsList: compared?.brandStoreChartsList,
                brandStoreCityList: compared?.brandStoreCityList,
              }}
              hasUnlock={hasUnlock}
            />
          </div>
        ),
      },
      {
        id: '7-4',
        content: (
          <div style={{ paddingBottom: '20px' }}>
            <ConsumerComplaints data={compared?.conBrandEsgList} hasUnlock={hasUnlock} />
          </div>
        ),
      },

      {
        id: '7-5',
        content: (
          <div style={{ paddingBottom: '20px' }}>
            {/*<UserOpinion data={compared?.userOpinion} selectList={selectList} />*/}
            <UserOpinion data={compared?.userOpinion} hasUnlock={hasUnlock} />
          </div>
        ),
      },
      {
        id: '7-6',
        content: (
          <div style={{ paddingBottom: '20px' }}>
            <SearchPopularitye data={compared?.brandHotSearchList} hasUnlock={hasUnlock} />
          </div>
        ),
      },
      {
        id: '8',
        content: <ChartHeader title="营销能力" titleFontSize={18} className={styles.header} />,
      },
      // {
      //   id: '8-1',
      //   content: (
      //     <div style={{ paddingBottom: '20px' }}>
      //       <Interaction data={compared?.interactionList} />
      //     </div>
      //   ),
      // },
      {
        id: '8-2',
        content: (
          <div style={{ paddingBottom: '20px' }}>
            <ProductionCapacity data={compared?.productionList} hasUnlock={hasUnlock} />
          </div>
        ),
      },
      {
        id: '8-3',
        content: (
          <div style={{ paddingBottom: '20px' }}>
            <PlatformRelated data={compared?.relatedContentList} hasUnlock={hasUnlock} />
          </div>
        ),
      },
    ],
    [
      compared?.brandHotSearchList,
      compared?.brandStoreChartsList,
      compared?.brandStoreCityList,
      compared?.brandproductinfo,
      compared?.business_capacity,
      compared?.conBrandEsgList,
      compared?.fansList,
      compared?.financingInfoList,
      compared?.finanncingList,
      compared?.hotTalkList,
      compared?.industryGrowSpaceList,
      compared?.organCompetencies,
      compared?.organPenetrate,
      compared?.organStrength,
      compared?.productionList,
      compared?.relatedContentList,
      compared?.supplyChain,
      compared?.userNiceList,
      compared?.userOpinion,
      disabledClose,
      hasUnlock,
      selectList,
      selectListCache,
      selectValue,
      setCompared,
    ]
  );

  return (
    <>
      <Layout
        title="品牌对比 | CBNData品牌数集"
        description="对比 | CBNData品牌数集是第一财经商业数据中心（CBNData）旗下一款衡量品牌综合实力的可视化数据工具，基于CBNData沉淀的中国新消费品牌增长力评估模型与数据能力，从品牌赛道潜力、组织能力、经营能力、产品竞争力、营销能力、供应链能力、用户发展能力等7个维度，系统化帮助投资人及品牌创始人衡量品牌综合实力、评估品牌风险、分析行业竞争格局以及挖掘高增长潜力的新锐品牌。"
        keyword="品牌对比、竞品、竞品分析、指标、品牌数集、CBNData、CBN、第一财经"
        isShowNavBar
        isFrapMain
        FooterComponent={Footer}
      >
        <div className={classnames('flex-row-nowrap', styles.content)}>
          <div className={styles.leftContent}>
            <MenuAnchor
              selectedKeys={selectedKeys}
              onSelect={onTabSelect}
              openKeys={openKeys}
              items={[
                // {
                //   label: '增长率综合指数',
                //   key: 'tabs-1',
                //   children: [
                //     {
                //       label: (
                //         <div className={classnames('flex-row-nowrap', 'flex-start-center')}>
                //           <Dot className={styles.dot} />
                //           <span>品牌增长指数情况</span>
                //         </div>
                //       ),
                //       key: 'tabs-1',
                //     },
                //     {
                //       label: (
                //         <div className={classnames('flex-row-nowrap', 'flex-start-center')}>
                //           <Dot className={styles.dot} />
                //           <span>品牌七大指标</span>
                //         </div>
                //       ),
                //       key: 'tabs-1',
                //     },
                //   ],
                // },
                {
                  label: '组织能力',
                  key: 'tabs-2',
                },
                // hasUnlock
                //   ? {
                //       label: '经营能力',
                //       key: 'tabs-3',
                //     }
                //   : null,
                {
                  label: '经营能力',
                  key: 'tabs-3',
                },
                {
                  label: '行业及品牌发展潜力',
                  key: 'tabs-4',
                  children: [
                    {
                      label: (
                        <div className={classnames('flex-row-nowrap', 'flex-start-center')}>
                          <Dot className={styles.dot} />
                          <span>母公司融资情况</span>
                        </div>
                      ),
                      key: 'tabs-4-1',
                    },
                    {
                      label: (
                        <div className={classnames('flex-row-nowrap', 'flex-start-center')}>
                          <Dot className={styles.dot} />
                          <span>母公司融资历程表</span>
                        </div>
                      ),
                      key: 'tabs-4-2',
                    },
                    {
                      label: (
                        <div className={classnames('flex-row-nowrap', 'flex-start-center')}>
                          <Dot className={styles.dot} />
                          <span>行业消费规模</span>
                        </div>
                      ),
                      key: 'tabs-4-3',
                    },
                    {
                      label: (
                        <div className={classnames('flex-row-nowrap', 'flex-start-center')}>
                          <Dot className={styles.dot} />
                          <span>品牌讨论热度</span>
                        </div>
                      ),
                      key: 'tabs-4-4',
                    },
                  ],
                },
                {
                  label: '产品竞争能力',
                  key: 'tabs-5',
                },
                {
                  label: '供应链管理能力',
                  key: 'tabs-6',
                },
                {
                  label: '用户发展能力',
                  key: 'tabs-7',
                  children: [
                    {
                      label: (
                        <div className={classnames('flex-row-nowrap', 'flex-start-center')}>
                          <Dot className={styles.dot} />
                          <span>社交平台官号粉丝规模</span>
                        </div>
                      ),
                      key: 'tabs-7-1',
                    },
                    {
                      label: (
                        <div className={classnames('flex-row-nowrap', 'flex-start-center')}>
                          <Dot className={styles.dot} />
                          <span>用户群拓展能力</span>
                        </div>
                      ),
                      key: 'tabs-7-2',
                    },
                    {
                      label: (
                        <div className={classnames('flex-row-nowrap', 'flex-start-center')}>
                          <Dot className={styles.dot} />
                          <span>线下门店分布</span>
                        </div>
                      ),
                      key: 'tabs-7-3',
                    },
                    {
                      label: (
                        <div className={classnames('flex-row-nowrap', 'flex-start-center')}>
                          <Dot className={styles.dot} />
                          <span>消费者投诉指数</span>
                        </div>
                      ),
                      key: 'tabs-7-4',
                    },
                    {
                      label: (
                        <div className={classnames('flex-row-nowrap', 'flex-start-center')}>
                          <Dot className={styles.dot} />
                          <span>品牌舆情分析</span>
                        </div>
                      ),
                      key: 'tabs-7-5',
                    },

                    {
                      label: (
                        <div className={classnames('flex-row-nowrap', 'flex-start-center')}>
                          <Dot className={styles.dot} />
                          <span>社交媒体热度</span>
                        </div>
                      ),
                      key: 'tabs-7-6',
                    },
                  ],
                },
                {
                  label: '营销能力',
                  key: 'tabs-8',
                  children: [
                    // {
                    //   label: (
                    //     <div className={classnames('flex-row-nowrap', 'flex-start-center')}>
                    //       <Dot className={styles.dot} />
                    //       <span>用户规模</span>
                    //     </div>
                    //   ),
                    //   key: 'tabs-8-1',
                    // },
                    {
                      label: (
                        <div className={classnames('flex-row-nowrap', 'flex-start-center')}>
                          <Dot className={styles.dot} />
                          <span>品牌官号内容量指数</span>
                        </div>
                      ),
                      key: 'tabs-8-2',
                    },
                    {
                      label: (
                        <div className={classnames('flex-row-nowrap', 'flex-start-center')}>
                          <Dot className={styles.dot} />
                          <span>平台相关内容量指数</span>
                        </div>
                      ),
                      key: 'tabs-8-3',
                    },
                  ],
                },
              ]}
            />
          </div>
          <div className={styles.rightContent}>
            {tabArr.map(item => (
              <ScrollableAnchor id={`tabs-${item.id}`} key={item.id}>
                <div>{item.content}</div>
              </ScrollableAnchor>
            ))}
          </div>
        </div>
      </Layout>
    </>
  );
}

export default BrandContrastPage;
